import styleEditResource from './style-edit-resources';
export default {
    accordionsWrapperStyle: styleEditResource,
    headingStyle: styleEditResource,
    paragraphStyle: styleEditResource,
    settings: {
        activeBgStyle: {
            visibleOn: ['normal', 'hover'],
            template: 'Tab',
            inputType: 'boxed',
            defaultValue: 'color',
            label: 'Background Style',
            options: [
                { label: 'Color', value: 'color' },
                { label: 'Gradient', value: 'gradient' },
                { label: 'Image', value: 'image' },
            ],
        },
    },
};
